/**
 * Бренд инстанса — единственное место, где живут названия площадок.
 *
 * Один и тот же код собирается под разные страны и под разными
 * брендами: Kassir.kg, Showgo.uz, Showgo.kz, Showgo.tj, Kassir.ru.
 * Раньше «Kassir.kg» был вписан руками в шапку, логин, заголовок
 * вкладки и превью рассылки — при сборке под KZ пользователь видел
 * чужой бренд.
 *
 * Выбор идёт по `VITE_COUNTRY_CODE`. Новая страна = одна запись здесь,
 * трогать компоненты не нужно.
 */

import {type CountryCode, env} from '@services/utils';

export type Brand = {
  /** Полное имя с доменной зоной — шапка, копирайт, превью. */
  name: string;
  /** Часть до точки — крупная в логотипе. */
  wordmarkMain: string;
  /** Доменная зона, приглушённая в логотипе. */
  wordmarkTld: string;
  /** Публичный сайт — ссылки на события и сеансы. */
  webUrl: string;
  /** Плейсхолдер поля e-mail на логине. */
  emailPlaceholder: string;
  /** Единица валюты в суммах. */
  currency: string;
  /** Страна по умолчанию для PhoneInput — определяет код (+996, +7…). */
  phoneCountry: 'kg' | 'uz' | 'ru' | 'kz' | 'tj';
  /** Пример номера в плейсхолдерах полей телефона. */
  phonePlaceholder: string;
};

const BRANDS: Record<CountryCode, Brand> = {
  kg: {
    name: 'Kassir.kg',
    wordmarkMain: 'Kassir',
    wordmarkTld: '.kg',
    webUrl: 'https://kassir.kg',
    emailPlaceholder: 'you@kassir.kg',
    currency: 'сом',
    phoneCountry: 'kg',
    phonePlaceholder: '+996 555 12 34 56',
  },
  kz: {
    name: 'Showgo.kz',
    wordmarkMain: 'Showgo',
    wordmarkTld: '.kz',
    webUrl: 'https://showgo.kz',
    emailPlaceholder: 'you@showgo.kz',
    currency: '₸',
    phoneCountry: 'kz',
    phonePlaceholder: '+7 701 123 45 67',
  },
  uz: {
    name: 'Showgo.uz',
    wordmarkMain: 'Showgo',
    wordmarkTld: '.uz',
    webUrl: 'https://showgo.uz',
    emailPlaceholder: 'you@showgo.uz',
    currency: 'сум',
    phoneCountry: 'uz',
    phonePlaceholder: '+998 90 123 45 67',
  },
  tj: {
    name: 'Showgo.tj',
    wordmarkMain: 'Showgo',
    wordmarkTld: '.tj',
    webUrl: 'https://showgo.tj',
    emailPlaceholder: 'you@showgo.tj',
    currency: 'сомони',
    phoneCountry: 'tj',
    phonePlaceholder: '+992 90 123 45 67',
  },
  ru: {
    name: 'Kassir.ru',
    wordmarkMain: 'Kassir',
    wordmarkTld: '.ru',
    webUrl: 'https://kassir.ru',
    emailPlaceholder: 'you@kassir.ru',
    currency: '₽',
    phoneCountry: 'ru',
    phonePlaceholder: '+7 900 123 45 67',
  },
};

/** Бренд текущей сборки. Константа — env не меняется в рантайме. */
export const brand: Brand = BRANDS[env.VITE_COUNTRY_CODE] ?? BRANDS.kg;
